var _path, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsaxGlobalRefresh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2214)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2214",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H0V15H15V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83008 9.60522C2.29219 9.72132 2.75926 9.81935 3.22852 9.9021C3.30821 10.3689 3.40369 10.8357 3.51953 11.2976C2.84343 10.8631 2.26665 10.2834 1.83008 9.60522Z",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.59668 1.82251C10.2809 2.25999 10.8642 2.84365 11.3047 3.53052C10.8428 3.40799 10.3758 3.30574 9.9082 3.2229C9.82437 2.75315 9.71926 2.28491 9.59668 1.82251Z",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.51465 1.83252C3.39986 2.29366 3.30473 2.75784 3.22266 3.22314C2.75286 3.30701 2.28437 3.41211 1.82031 3.53467C2.25935 2.85139 2.83865 2.26795 3.51465 1.83252Z",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.56348 0.918701C6.96823 0.918717 7.36732 0.972707 7.75488 1.0564C7.9708 1.69307 8.13213 2.34918 8.26562 3.01245C7.13165 2.91308 5.99432 2.91304 4.86035 3.01245C4.995 2.34971 5.1603 1.69218 5.37207 1.05347C5.75861 0.968228 6.15283 0.918701 6.56348 0.918701Z",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.0127 4.8584C2.91323 5.99237 2.91338 7.1297 3.0127 8.26367C2.3473 8.12899 1.69329 7.96407 1.05371 7.75195C0.968693 7.36595 0.91896 6.97254 0.918945 6.5625C0.918945 6.15747 0.972867 5.75792 1.05664 5.37012C1.69413 5.1539 2.34678 4.9919 3.0127 4.8584Z",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1064 4.85938C10.7682 4.99383 11.4247 5.1588 12.0625 5.37012C12.1488 5.75896 12.2002 6.15355 12.2002 6.55566C12.2002 6.96385 12.1457 7.35771 12.0625 7.74707C11.4258 7.96301 10.7697 8.12431 10.1064 8.25781C10.2097 7.12853 10.2099 5.99258 10.1064 4.85938Z",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.86035 10.1133C5.4232 10.166 5.99111 10.2019 6.56055 10.207H6.56348C7.13454 10.207 7.70328 10.1682 8.26465 10.1143C8.13014 10.7786 7.9656 11.4317 7.75391 12.0703C7.36947 12.156 6.9705 12.207 6.56348 12.207C6.15521 12.207 5.7615 12.1526 5.37207 12.0693C5.15582 11.4318 4.99387 10.7792 4.86035 10.1133Z",
    stroke: "white",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61523 4.61499C5.91078 4.4681 7.21493 4.46804 8.51562 4.61499C8.66261 5.91572 8.6625 7.2198 8.51562 8.51538C7.2149 8.66234 5.91081 8.66228 4.61523 8.51538C4.46828 7.21468 4.46834 5.91054 4.61523 4.61499Z",
    stroke: "white",
    strokeWidth: 0.6
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6924 11.3216L12.9912 11.4861C12.4903 11.6006 12.0967 11.9942 11.9822 12.4951L11.8177 13.1963C11.8033 13.2679 11.696 13.2679 11.6745 13.1963L11.51 12.4951C11.3955 11.9942 11.0019 11.6006 10.501 11.4861L9.79976 11.3216C9.7282 11.3073 9.7282 11.1999 9.79976 11.1785L10.501 11.0139C11.0019 10.8994 11.3955 10.5058 11.51 10.0049L11.6745 9.30367C11.6888 9.23211 11.7962 9.23211 11.8177 9.30367L11.9822 10.0049C12.0967 10.5058 12.4903 10.8994 12.9912 11.0139L13.6924 11.1785C13.764 11.1928 13.764 11.3001 13.6924 11.3216Z",
    fill: "#34D399"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsaxGlobalRefresh);
export default __webpack_public_path__ + "static/media/iconsax-global-refresh.e20599deb0d09d2bee01027784e76620.svg";
export { ForwardRef as ReactComponent };